import { render, staticRenderFns } from "./CostSaleforService.vue?vue&type=template&id=408db20e&"
import script from "./CostSaleforService.vue?vue&type=script&lang=js&"
export * from "./CostSaleforService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports